import { SET_INFO_MESSAGE, CLEAR_INFO_MESSAGE } from "./constants";

export const setInfoMessage = (payload) => ({
  type: SET_INFO_MESSAGE,
  payload
});

export const clearInfoMessage = () => ({
  type: CLEAR_INFO_MESSAGE
});
